import { render, staticRenderFns } from "./secondCategory.vue?vue&type=template&id=0c40e143&scoped=true"
import script from "./secondCategory.vue?vue&type=script&lang=js"
export * from "./secondCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40e143",
  null
  
)

export default component.exports